'use client';

import { logError } from "../console/logError.js";
function debounce(fn, debounceMs) {
  let debounceTimeout;
  return (...args) => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => {
      try {
        fn(...args);
      } catch (e) {
        logError("Error in debounce callback", e);
      }
    }, debounceMs);
  };
}
export {
  debounce
};
